import Container from 'atoms/Container';
import Button from 'layout/atoms/Button';
import Grid from 'layout/atoms/Grid';
import ProjectsList from 'layout/organisms/ProjectsList/ProjectsList';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { selectWorkspaceData } from 'store/workspaceSlice';
import { AddProject } from './AddProject';
import EmptyState from './EmptyState';
import { ProjectsArchive } from './ProjectsArchive';
import WorkspaceTasks from './WorkspaceTasks';

const PlanPage = () => {
    const workspaceData = useSelector(selectWorkspaceData);
    const [displayArchive, setDisplayArchive] = useState<boolean>(false);

    useEffect(() => {}, []);
    const navigate = useNavigate();

    return (
        <>
            <Container size="s">
                <WorkspaceTasks />
            </Container>
            <ProjectsList />
            <Container size="s" marginTop="16">
                <Grid columns={1} gap={12}>
                    {workspaceData.projects.length === 0 && <EmptyState />}
                    <AddProject />
                    <div>
                        {!workspaceData.access.archives && (
                            <small
                                style={{ opacity: 0.8, cursor: 'pointer' }}
                                onClick={() => navigate('/subscription')}
                            >
                                +{workspaceData.archivedProjectsCount} archived
                                projects
                            </small>
                        )}
                        {workspaceData.access.archives &&
                            workspaceData.archivedProjectsCount > 0 &&
                            !displayArchive && (
                                <Button
                                    theme="blank"
                                    onClick={() => setDisplayArchive(true)}
                                >
                                    Show archived projects (
                                    {workspaceData.archivedProjectsCount})
                                </Button>
                            )}
                        {workspaceData.access.archives &&
                            workspaceData.archivedProjectsCount > 0 &&
                            displayArchive && (
                                <Button
                                    theme="blank"
                                    onClick={() => setDisplayArchive(false)}
                                >
                                    Hide archived projects
                                </Button>
                            )}
                    </div>
                </Grid>
            </Container>
            <Container size="s" marginTop="16">
                {workspaceData.archivedProjectsCount > 0 && displayArchive && (
                    <ProjectsArchive />
                )}
            </Container>
        </>
    );
};

export default PlanPage;
